import getAccountBalancesGroupedPayin from "../../../../graphQl/queries/getAccountBalancesGroupedPayin";

export const getAccountBalancesGroupedQueryPayin = async ({commit, dispatch}, payload) => {
    let balancesData;
    try {
        balancesData = await dispatch('app/request', {
            type: 'query',
            gql: getAccountBalancesGroupedPayin,
            variables: payload,
        }, {root: true});
    } catch (error) {
        return error;
    } finally {}

    if (balancesData.data) {
        commit('accountBalancesGroupedPayin', balancesData.data.getAccountBalancesGrouped)
    }

    return balancesData;
};
